import { render, staticRenderFns } from "./AdminBirthdayModal.vue?vue&type=template&id=57ace76b"
import script from "./AdminBirthdayModal.vue?vue&type=script&lang=js"
export * from "./AdminBirthdayModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports